import actions from './actions'
import mutations from './mutations'
import getters from './getters'
export default {
    state: {
        invitations: [],
        invitation: {},
        newInvitation: {},
    },
    actions,
    mutations,
    getters
}
